import { useRef } from "react";
import { Link } from "react-router-dom";
import { getIcon } from "@/components/Icons";
import { useFocusTrap } from "./useFocusTrap";
import type { Area } from "./model";

/** Phone pull-up sheet: an area's pages, or (from More) the areas that didn't fit the bottom bar. */
export function AreaSheet({ area, areas, activeItemId, onPickArea, onClose }: {
  area: Area | null;
  areas: Area[];
  activeItemId: string | null;
  onPickArea: (area: Area) => void;
  onClose: () => void;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useFocusTrap(ref, onClose);
  const title = area ? area.label : "More";

  return (
    <>
      <div className="sheet-scrim" onClick={onClose} />
      <div className="sheet" role="dialog" aria-modal="true" aria-label={title} ref={ref}>
        <div className="sheet-handle" aria-hidden="true" />
        <h2>{title}</h2>
        {area
          ? area.groups.map((g, gi) => (
            <div key={g.label ?? gi}>
              {g.label && <div className="sheet-group">{g.label}</div>}
              {g.items.map((it) => {
                const I = getIcon(it.icon);
                return it.external
                  ? <a key={it.id} className="sheet-link" href={it.path} target="_blank" rel="noreferrer" onClick={onClose}><I size={18} />{it.label}</a>
                  : (
                    <Link key={it.id} className="sheet-link" to={it.path}
                      aria-current={it.id === activeItemId ? "page" : undefined} onClick={onClose}>
                      <I size={18} />{it.label}
                    </Link>
                  );
              })}
            </div>
          ))
          : areas.map((a) => {
            const I = getIcon(a.icon);
            return <button key={a.id} type="button" className="sheet-link" onClick={() => onPickArea(a)}><I size={18} />{a.label}</button>;
          })}
      </div>
    </>
  );
}
